import { getAuth } from "firebase/auth";

export default async function getIdToken(): Promise<{
    tokenType: "Bearer";
    token: string;
}> {
    const auth = getAuth();
    const token = await auth.currentUser?.getIdToken();
    return token
        ? { tokenType: "Bearer", token }
        : Promise.reject(new Error("No user"));
}
